<script>
import {
  FolderServiceProxy,
  ManageDirectoryServiceProxy,
  ResourceServiceProxy
} from "@/service-proxies/app-v2/dnc.service-proxies";
import dayjs from "dayjs";
import ViewDetail from "@/components/ViewDetail/index.vue";
import {canPreviewList, previewMode} from '@/utils/commonDef'

const serviceProxy = new FolderServiceProxy();
const serviceProxyDirectory = new ManageDirectoryServiceProxy();
const serviceProxyResource = new ResourceServiceProxy();

function textFilter(text) {
  return text.length > 8 ? `${text.substr(0, 8)}...` : text;
  // return text.replace(/.*(?=.{12}$)/, "...");
}

const fileMap = function(type) {
  let src = "";
  switch (type) {
    case "txt":
      src = require("@/assets/images/file/file_txt.svg");
      break;
    case "doc":
      src = require("@/assets/images/file/file_word.svg");
      break;
    case "xlsx":
      src = require("@/assets/images/file/file_excel.svg");
      break;
    case "pdf":
      src = require("@/assets/images/file/file_pdf.svg");
      break;
    case "png":
    case "jpg":
      src = require("@/assets/images/file/file_img.svg");
      break;
    case "mp4":
    case "wmv":
    case "avi":
      src = require("@/assets/images/file/file_video.svg");
      break;
    default:
      break;
  }
  return src;
};

const analyzeTree = tree => {
  tree.forEach(t => {
    t.key = t.id;
    if (t.children && t.children.length > 0) {
      analyzeTree(t.children);
    } else {
      delete t.children;
    }
  });
};

export default {
  components: {
    ViewDetail
  },
  props: {
    showType: {
      type: Number,
      default: 0
    },
    type: {
      validator: function(value) {
        return ["file", "source"].includes(value);
      }
    }
  },
  data() {
    return {
      selectMeta: null,
      fileList: [],
      treeData: [],
      show: false,
      sourceList: [],
      detail: {},
      detailvisible: false,
      sourceColumns: [
        {
          width: 100,
          title: this.$t('page_process_package_name'),
          dataIndex: "displayName"
        },
        {
          width: 100,
          title: this.$t('page_devices_management_satus'),
          customRender: () => this.$t('page_transport_published')
        },
        {
          width: 200,
          title: this.$t('page_transport_directory_custom_fields'),
          dataIndex: "nameValues",
          customRender: item => {
            if (!item || !item.length) {
              return this.$t('page_workstation_empty');
            }
            return (
              <div>
                {item.slice(0, 2).map(n => (
                  <span class="custom-span">{`${n.name}: ${dayjs(n.value).format("YYYY-MM-DD HH:mm:ss")}`}</span>
                ))}
                {item.length > 2 ? "..." : null}
              </div>
            );
          }
        },
        {
          title: this.$t('page_transport_directory_release_date'),
          dataIndex: "publishDatetime",
          customRender: item => dayjs(item).format("YYYY-MM-DD HH:mm:ss")
        }
      ],
      viewContentType: canPreviewList
    };
  },
  computed: {
    isFile() {
      return this.type === "file";
    },
    isScouce() {
      return this.type === "source";
    }
  },
  async mounted() {
    console.log(this.type)

    if (this.isFile) {
      this.treeData = [
        {
          id: "0",
          key: "0",
          title: this.$t("page_my_document")
        }
      ];
      this.renderTree();
    }

    if (this.isScouce) {
      const data = await this.getDirectorys();
      analyzeTree(data);
      this.treeData = data;
    }
  },
  methods: {
    closeDetail(bool) {
      this.detailvisible = false;
      this.detail = {};
    },
    showViewDetail(record) {
      if (record.suffix === 'zip') {
        return
      }
      record.name = record.name || record.displayName;
      this.detail = {};
      // if (this.canEdit(record)) {
        this.detail = record;
        this.detailvisible = true;
      // } else {
      //   this.detailvisible = false;
      // }
    },
    canEdit(record){
      let bool = false
      if(record.name.indexOf('.') != -1){
        var a = /.*\.(.*)$/
        const suffix = a.exec(record.name)[1]
        // bool = this.viewContentType.includes(suffix.toLowerCase())
        bool = true
      } else {
        bool = true
      }
      return bool
    },
    async getDirectorys() {
      const data = await serviceProxyDirectory.treeList();
      return data;
    },
    async getDirectoryList(parent) {
      const data = await serviceProxyResource.publishedList(parent, {});
      this.sourceList = data;
    },
    async getFolderList(parent) {
      const data = await serviceProxy.folderList(parent);
      this.fileList = data.fileList;
    },
    async getFolders(id) {
      const data = await serviceProxy.lazyFolderList(id);
      return data;
    },
    async onLoadData(treeNode) {
      console.log(treeNode,'treeNode')
      if (treeNode.dataRef.children) return;
      const data = await this.getFolders(treeNode.dataRef.id);
      console.log(data,'aaaaaaaaaaaaaaa')
      treeNode.dataRef.children = data.map(item => ({
        id: item.id,
        title: item.name,
        key: item.id
      }));
      this.treeData = [...this.treeData];
    },
    onTreeSelect(node) {
      console.log('点击')
      if(node) {
      this.isFile
        ? this.getFolderList(node[0])
        : this.isScouce
        ? this.getDirectoryList(node[0])
        : null;
      }  
    },
    showDetail(meta) {
      this.show = true;
      this.selectMeta = meta;
    },
    renderTips() {
      return (
        <a-alert
          message={this.$t("page_transport_help_tips")}
          type="info"
          showIcon
          style="margin-bottom:20px"
        />
      );
    },
    renderTree() {
      const props = {
        showIcon: true,
        switcherIcon: true,
        defaultExpandAll: true,
        blockNode: true,
        showLine: false,
        treeData: this.treeData
      };
      if (this.isFile) props.loadData = this.onLoadData;

      let copy = this.treeData
      copy.forEach((x) => {
            x.scopedSlots = {
              title: 'custom'
            }
            x.name = x.title;
            if(x.children) {
              x.children.forEach((y) => {
                y.scopedSlots = {
                  title: 'custom'
                }
                y.name = y.title;  
                if(y.children) {
                  y.children.forEach((z) => {
                    z.scopedSlots = {
                      title: 'custom'
                    }
                    z.name = z.title;
                    if(z.children) {
                      z.children.forEach((a) => {
                        a.scopedSlots = {
                          title: 'custom'
                        }
                        a.name = a.title;
                      })
                    }
                  })
                }
              })
            }
          })
      this.treeData = copy

      console.log('this.treeData',this.treeData)

      const renderTemplate = (context) => {

      console.log(context,'查看数据',this.treeProps,props)
      // this.onTreeSelect();
      const excludes = new Set(context.excludes);
      let show = null
      if(this.type == 'file') {
        show = (
        <div>
          <span>{context.title}</span>
          {context.expanded ? (

            context.children.length > 0 ? (
              <a-icon type="folder-open" theme='filled' style='color: #4a90e2; font-size: 16px; position: absolute; left: -23px; top: 4px; z-index: 90;'/>
            )  : ''

          ) : (
            context.children ? (
              <a-icon type="folder" theme='filled' style='color: #4a90e2; font-size: 16px; position: absolute; left: -23px; top: 4px; z-index: 90;'/>
            ) : <a-icon type="folder" theme='filled' style='color: #4a90e2; font-size: 16px; position: absolute; left: -23px; top: 4px; z-index: 90;'/>

              
            
          )}
        </div>
      );
      } 
      else {
        show = (
        <div>
          <span>{context.title}</span>
          {context.expanded ? (

            context.children ? (
              <a-icon v-if='context.children' type="folder-open" theme='filled' style='color: #4a90e2; font-size: 16px; position: absolute; left: -23px; top: 4px; z-index: 90;'/>
            )  : ''

          ) : (
            context.children ? (
              <a-icon type="folder" theme='filled' style='color: #4a90e2; font-size: 16px; position: absolute; left: -23px; top: 4px; z-index: 90;'/>
            ) : 

              (context.title == '我的文档' ? 

                (context.children ? 
                <a-icon type="folder-open" theme='filled' style='color: #4a90e2; font-size: 16px; position: absolute; left: -23px; top: 4px; z-index: 90;'/>
                :
                <a-icon type="folder" theme='filled' style='color: #4a90e2; font-size: 16px; position: absolute; left: -23px; top: 4px; z-index: 90;'/>
                )  
                :
                ''
              )
            
          )}
        </div>
      );
      }     

      
      return show;
    };

    const renderTemplateIcon = (context) => {
      console.log(context.id,'查看数据')
      const icon = (
        <a-icon type="folder" theme='filled' style='color: rgba(74,144,226,0); font-size: 20px; position: relative; z-index: 99;'/>
      );
      return icon;
    };


      // if (this.isFile) props.loadData = this.onLoadData;


      let trees = h("a-tree", {
          props: props,
          on: {
            select: this.onTreeSelect
          },
          loadData: this.loadData,
          scopedSlots: {
            custom: (context) => renderTemplate(context),
            switcherIcon: (context) => renderTemplateIcon(context),
          },
          class: 'wrapper-left',
        })

        return trees;

      //  return (
      //    <a-tree
      //      class="wrapper-left"
      //      {...{ props: props }}
      //      onSelect={this.onTreeSelect}
      //      scopedSlots= {{
      //       custom= (context) => renderTemplate(context),
      //       switcherIcon= (context) => renderTemplateIcon(context)
      //      }
      //     }
      //    ></a-tree>
      //  );
    },
    renderSourceMeta(meta) {
      const canDrag =
        this.$store.getters.buttons.includes("page_transport_drag") &&
        meta.fileList.length > 0;
      return (
        <div
          key={meta.id}
          class="source-meta"
          onClick={e => this.showDetail(meta)}
          v-draggable={{
            meta: {
              ...meta,
              _type: "source"
            },
            canDrag
          }}
        >
          <div class="source-meta-header">
            <div>
              <span class="span1">{meta.displayName}</span>
              <span class="span2">({meta.currentVersion})</span>
            </div>
            <div>
              <i class="publish"></i>
              {this.$t("page_transport_published")}
            </div>
          </div>
          <div class="source-meta-body">
            <div>
              {meta.nameValues.slice(0, 2).map(n => (
                <span>{`${n.name}: ${n.value}`}</span>
              ))}
              {meta.nameValues.length > 2 ? "..." : null}
            </div>
            <div>
              <span class="span1">
                {this.$t("page_transport_publish_date")}:
              </span>
              <span class="span2">
                {dayjs(meta.publishDatetime).format("YYYY-MM-DD HH:mm:ss")}
              </span>
            </div>
          </div>
        </div>
      );
    },
    renderSource() {
      return (
        <div class="wrapper-right">
          {this.renderTips()}
          {!this.showType ? (
            <ml-table
              size="small"
              rowKey="id"
              columns={this.sourceColumns}
              dataSource={this.sourceList}
              canChangeColWidth={true}
              customRow={row => {
                const canDrag =
                  this.$store.getters.buttons.includes("page_transport_drag") &&
                  row.fileList.length > 0;
                const value = {
                  meta: {
                    ...row,
                    _type: "source"
                  },
                  canDrag
                };
                return {
                  on: {
                    click: () => {
                      this.showDetail(row);
                    }
                  },
                  directives: [
                    {
                      name: "draggable",
                      value: value
                    }
                  ]
                };
              }}
            ></ml-table>
          ) : (
            <div class="sources-wrapper">
              {this.sourceList.map(item => {
                return this.renderSourceMeta(item);
              })}
            </div>
          )}
        </div>
      );
    },
    renderFileMeta(meta) {
      const canDrag = this.$store.getters.buttons.includes(
        "page_transport_drag"
      );
      const src = fileMap(meta.suffix);

      const icon = src ? (
        <img src={src} />
      ) : (
        <a-icon
          class="icon-class"
          type="file-text"
          theme="twoTone"
          twoToneColor="#92a8c1"
        />
      );

      return (
        <div
          key={meta.id}
          class="file-meta"
          v-draggable={{
            meta: {
              ...meta,
              _type: "file"
            },
            canDrag
          }}
          onClick={() => this.showViewDetail(meta)}
        >
          {icon}
          <a-tooltip>
            <template slot="title">{meta.name}</template>
            {textFilter(meta.name)}
          </a-tooltip>
        </div>
      );
    },
    renderFile() {
      return (
        <div class="wrapper-right">
          {this.renderTips()}
          <div class="files-wrapper">
            {this.fileList.map(item => {
              return this.renderFileMeta(item);
            })}
          </div>
        </div>
      );
    },
    renderWmDrawer() {
      const title = this.selectMeta
        ? `${this.selectMeta.displayName}(${this.selectMeta.currentVersion})`
        : "";
      const props = {
        title: title,
        width: "680px",
        mask: false,
        visible: this.show,
        getContainer: ".content-right",
        placement: "right",
        bodyStyle: { padding: "16px" },
        wrapStyle: { position: "absolute" }
      };

      const nameValues = this.selectMeta && this.selectMeta.nameValues;

      const programFiles =
        (this.selectMeta &&
          this.selectMeta.fileList.filter(file => file.fileType == 1)) ||
        [];
      const documentFiles =
        (this.selectMeta &&
          this.selectMeta.fileList.filter(file => file.fileType == 2)) ||
        [];

      return (
        <a-drawer {...{ props: props }} onClose={e => (this.show = false)}>
          <div>
            {nameValues &&
              nameValues.length > 0 &&
              this.renderDrawerFields("text", nameValues)}
            {programFiles.length > 0 &&
              this.renderDrawerFields("program", programFiles)}
            {documentFiles.length > 0 &&
              this.renderDrawerFields("document", documentFiles)}
          </div>
        </a-drawer>
      );
    },
    renderDrawerFields(type, files) {
      const contentText = file => (
        <div class="drawer-meta-text">
          {file.name}:<span>{dayjs(file.value).valueOf() ? dayjs(file.value).format('YYYY-MM-DD HH:mm:ss') : file.value }</span>
        </div>
      );

      const contentFile = file => {
        const src = fileMap(file.suffix);

        const icon = src ? (
          <img src={src} />
        ) : (
          <a-icon
            class="icon-class"
            type="file-text"
            theme="twoTone"
            twoToneColor="#92a8c1"
          />
        );

        return (
          <div
            class="drawer-meta-file"
            onClick={() => this.showViewDetail(file)}
          >
            {icon}
            <a-tooltip>
              <template slot="title">{file.displayName}</template>
              {textFilter(file.displayName)}
            </a-tooltip>
          </div>
        );
      };

      const map = {
        text: {
          title: this.$t("page_transport_custom_text"),
          render: contentText
        },
        program: {
          title: this.$t("page_resource_pool_job_gram"),
          render: contentFile
        },
        document: {
          title: this.$t("page_resource_pool_art"),
          render: contentFile
        }
      };

      return (
        <div class="field-wrapper">
          <div class="field-header">{map[type].title}</div>
          <div class="field-content">
            {files.map(file => map[type].render(file))}
          </div>
        </div>
      );
    }
  },
  render() {
    const tree = this.renderTree();
    const file = this.isFile ? this.renderFile() : null;
    const source = this.isScouce ? this.renderSource() : null;

    return (
      <div class="tsof-wrapper wrapper">
        {tree}
        <div v-resize={"x"}></div>
        {file}
        {source}
        {this.renderWmDrawer()}
        <viewDetail
          footer={false}
          visible={this.detailvisible}
          item={this.detail}
          onClose={this.closeDetail}
        />
      </div>
    );
  }
};
</script>

<style lang="less">
.tsof-wrapper {
  .ant-table td {
    white-space: nowrap;
  }
}
</style>

<style lang="less" scoped>
.wrapper {
  display: flex;
  align-items: stretch;
  height: 100%;
  position: relative;

  .wrapper-left {
    width: 250px;
    border-right: 1px solid #e8e8e8;
    overflow-y: auto;
    padding: 0 8px;
  }

  .wrapper-right {
    flex-grow: 1;
    margin-right: 16px;
    overflow-y: auto;

    .content-tips {
      padding-left: 16px;
      height: 40px;
      background-color: #d0edff;
      border-radius: 2px;
      border: solid 1px #4a90e2;
      line-height: 38px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      i {
        margin-right: 10px;
      }
    }

    .files-wrapper,
    .sources-wrapper {
      overflow-y: auto;
      display: flex;
      align-content: flex-start;
      flex-wrap: wrap;
      margin-top: 8px;
      margin-left: -8px;
      margin-right: -8px;

      .file-meta {
        width: 137px;
        height: 137px;
        margin: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background-color: transparent;

        img {
          width: 64px;
          height: 64px;
        }
      }

      .source-meta {
        width: 300px;
        // width: calc((100% - 48px) / 3);
        background-color: #ffffff;
        border-radius: 2px;
        border: solid 1px rgba(0, 0, 0, 0.15);
        margin: 8px;
        border-radius: 2px;
        height: 132px;
        cursor: pointer;

        .source-meta-header {
          height: 46px;
          align-items: center;
          padding-left: 16px;
          padding-right: 16px;
          background: #d0edff;
          display: flex;
          justify-content: space-between;
          font-size: 14px;

          .span1 {
            font-size: 16px;
            color: rgba(0, 0, 0, 0.85);
            margin-right: 5px;
          }
          .span2 {
            font-size: 16px;
            color: #4a90e2;
          }

          > div:last-of-type {
            display: flex;
            align-items: center;

            i.publish {
              display: block;
              border-radius: 50%;
              width: 5px;
              height: 5px;
              background: #71ce52;
              margin-right: 8px;
            }
          }
        }
        .source-meta-body {
          > div:first-of-type {
            display: flex;
            margin: 16px;
            height: 20px;

            span {
              font-size: 14px;
              height: 20px;
              padding-left: 10px;
              padding-right: 10px;
              line-height: 18px;
              background-color: #e6f7ff;
              border-radius: 2px;
              border: solid 1px #91d5ff;
              margin-right: 8px;
              max-width: 100px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          > div:last-of-type {
            margin-left: 16px;
            font-size: 14px;

            .span1 {
              color: rgba(0, 0, 0, 0.85);
              margin-right: 5px;
            }

            .span2 {
              color: rgba(0, 0, 0, 0.65);
            }
          }
        }
      }
    }
  }
}

.field-wrapper {
  margin-bottom: 16px;

  .field-header {
    height: 24px;
    line-height: 24px;
    padding-left: 12px;
    border-left: 4px solid #457cbe;
  }

  .field-content {
    margin-top: 16px;

    .drawer-meta-text {
      padding-left: 40px;

      span {
        padding-left: 10px;
        padding-right: 10px;
        margin-left: 10px;
        line-height: 18px;
        background-color: #e6f7ff;
        border-radius: 2px;
        border: solid 1px #91d5ff;
      }

      &:not(:last-of-type) {
        margin-bottom: 20px;
      }
    }

    .drawer-meta-file {
      width: 146px;
      height: 146px;
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      img {
        width: 64px;
        height: 64px;
      }
    }
  }
}

.icon-class {
  font-size: 60px;
  margin-bottom: 10px;
}

.custom-span {
  font-size: 14px;
  height: 21px;
  padding-left: 10px;
  padding-right: 10px;
  line-height: 19px;
  background-color: #e6f7ff;
  border-radius: 2px;
  border: solid 1px #91d5ff;
  margin-right: 8px;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}


/deep/ .ant-tree-treenode-selected > span .right-drop-down {
    display: block !important;
  }

  /deep/ .ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-icon svg {
    transform: rotate(0deg)!important;
  }

  /deep/ .ant-tree-title {
    position: relative;
    z-index: 99;
  }

  /deep/ .ant-tree-switcher {
    color: rgba(0, 0, 0, 0)!important;
  }

  /deep/ .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background-color: rgb(255, 241, 184);
  }

  /deep/ .ant-tree li span.ant-tree-switcher {
    z-index: 99;
  }
  
</style>
